import { MatPaginatorIntl } from '@angular/material/paginator';
import { Injectable } from '@angular/core';

@Injectable()
export class App24PAMatPaginator extends MatPaginatorIntl {
  itemsPerPageLabel: string;
  firstPageLabel: string;
  nextPageLabel: string;
  previousPageLabel: string;
  lastPageLabel: string;
  messagesTotalLength: number; // numero di elementi totali nel DB

  constructor() {
    super();
    this.getAndInitTranslations();
  }

  getAndInitTranslations() {
    this.itemsPerPageLabel = '';
    this.firstPageLabel = 'Prima pagina';;
    this.nextPageLabel = 'Pagina successiva';
    this.previousPageLabel = 'Pagina precedente';
    this.lastPageLabel = 'Ultima pagina';
    this.changes.next();
  }

  getRangeLabel = (page: number, pageSize: number, length: number) => {
    if (length === 0 || pageSize === 0) {
      return `0 di ${length}`;
    }
    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
    return `${startIndex + 1} - ${endIndex} di ${length}`;
  }

}